__turbopack_context__.v({
  "big": "VideoPlayer-module-scss-module__Vnpk7q__big",
  "video-iframe": "VideoPlayer-module-scss-module__Vnpk7q__video-iframe",
});
